import { Component, EventEmitter, Input, Output, OnChanges, ElementRef, ViewChild, SimpleChanges } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { saveAs } from 'file-saver'
import { DomSanitizer } from '@angular/platform-browser'
import { Observable } from 'rxjs'
import { renderAsync } from 'docx-preview'
import { LoadingService } from 'src/app/services/common/loading.service'

@Component({
  selector: 'app-document-preview',
  templateUrl: './document-preview.component.html',
  styleUrls: ['./document-preview.component.scss']
})
export class DocumentPreviewComponent implements OnChanges {
  @Input() documentUrl: string
  @Input() hasNext: boolean
  @Input() hasPrevious: boolean
  @Output() requestNextDocument = new EventEmitter<void>()
  @Output() requestPreviousDocument = new EventEmitter<void>()
  @Output() close = new EventEmitter<void>()
  @ViewChild('docxContainer') docxContainer: ElementRef

  isVisible = false
  pdfSrc: string | ArrayBuffer = ''
  scale = 1.0
  isPdf = false
  isDoc = false
  isImage = false
  documentUrlWithoutFileName: string
  pdfPage: number = 1
  pdfTotalPages: number
  isPDFLoaded: boolean = false

  constructor(private http: HttpClient, public sanitizer: DomSanitizer, private loadingService: LoadingService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['documentUrl'] && changes['documentUrl'].currentValue) {
      this.loadDocument()
      this.openModal()
    }
  }

  openModal(): void {
    this.isVisible = true
    this.loadDocument()
  }

  closeModal(): void {
    this.isVisible = false
    this.close.emit()
  }

  loadDocument(): void {
    const fileExtension = this.documentUrl.split('.').pop().toLowerCase()
    this.documentUrlWithoutFileName = this.extractBlobUrl(this.documentUrl)
    this.scale = 1
    if (fileExtension === 'pdf') {
      this.isPdf = true
      this.isDoc = false
      this.isImage = false
      this.loadPdf()
    } else if (fileExtension === 'doc' || fileExtension === 'docx') {
      this.isPdf = false
      this.isDoc = true
      this.isImage = false
      this.loadDoc()
    } else if (fileExtension === 'jpg' || fileExtension === 'jpeg' || fileExtension === 'png') {
      this.isPdf = false
      this.isDoc = false
      this.isImage = true
    }
  }

  loadPdf(): void {
    this.http.get(this.documentUrlWithoutFileName, { responseType: 'arraybuffer' }).subscribe((response) => {
      this.pdfSrc = new Uint8Array(response)
      setTimeout(() => {
        this.loadingService.hide()
      }, 10)
    })
  }

  zoomIn(): void {
    if (this.scale <= 1.6) {
      this.scale += 0.1
    }
  }

  zoomOut(): void {
    if (this.scale >= 1) {
      this.scale -= 0.1
    }
  }

  loadDoc(): void {
    this.getDocumentBlob(this.documentUrlWithoutFileName).subscribe((blob) => {
      renderAsync(blob, this.docxContainer.nativeElement)
    })
  }

  nextDocument(): void {
    this.requestNextDocument.emit()
  }

  previousDocument(): void {
    this.requestPreviousDocument.emit()
  }

  downloadDocument(): void {
    this.http.get(this.documentUrlWithoutFileName, { responseType: 'blob' }).subscribe((response: Blob) => {
      saveAs(response, this.extractTypeFromBlobUrl(this.documentUrl))
    })
  }

  extractTypeFromBlobUrl(url: string): string | null {
    const regex = /[?&]type=([^&#]*)/
    const match = url.match(regex)
    return match ? decodeURIComponent(match[1]) : null
  }

  extractBlobUrl(baseUrl: string): string {
    let parts = baseUrl.split('?')
    let baseUrlWithoutQuery = parts[0]
    parts = baseUrlWithoutQuery.split('#')
    let baseUrlWithoutFragment = parts[0]
    return baseUrlWithoutFragment
  }

  afterPDFLoadComplete(pdfData: any) {
    this.pdfTotalPages = pdfData.numPages
    this.isPDFLoaded = true
  }

  getDocumentBlob(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' })
  }
}
